const whenElementExists = (selector: any, callback: Function, doesntExist: Function = () => {}) => {
  const element = document.querySelector(selector)
  if (element) {
    return callback(element)
  } else {
    console.debug('Queried selector "', selector, '" doesnt exist.')
    return doesntExist(selector)
  }
}

const elementHeight = (selector: any) => {
  return whenElementExists(selector, (element: { getBoundingClientRect: () => { (): any; new(): any; height: any } }) => {
    return element.getBoundingClientRect().height
  })
}

const elementWidth = (selector: any) => {
  return whenElementExists(selector, (element: { getBoundingClientRect: () => { (): any; new(): any; width: any } }) => {
    return element.getBoundingClientRect().width
  })
}

const patchElement = (selector: string, content = '') => {
  const element = document.querySelector(selector)

  if (element) {
    element.innerHTML = String(content)
  }
}

export default {
  measure: {
    elementHeight,
    elementWidth
  },
  patchElement
}